import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReviewsList from './reviews_list/ReviewsList';
import RankingUser from './user_ranking/RankingUser';
import Header from './header/header';
import NoReviews from './no_reviews/NoReviews';
import * as actions from './module';
import translations from '../translations.en.json';
import '@fiverr/i18n/singleton';
import classnames from 'classnames';
import { round } from './utils';
import './my-reviews.scss';

class Index extends React.Component {

    constructor() {
        super();
        i18n.add(translations);

        this.toggleCollapsed = this.toggleCollapsed.bind(this);

        this.state = {
            collapsed: true
        };
    }

    toggleCollapsed(e) {
        if ((e.target) && (e.target.nodeName !== 'SELECT')) {
            this.setState({
                collapsed: !this.state.collapsed
            });
        }
    }

    mainClassName() {
        return classnames('reviews-package', {
            'show': !this.state.collapsed
        });
    }

    calcRatingBaseFive() {
        const { averageValuation } = this.props;

        if (!averageValuation) { return false; }

        const convertedRating = (averageValuation / 20);
        return round(convertedRating, 1);
    }

    /*
    * Calculates the last review from the reviews list.
    * @returns {Number|undefined} id of last review or undefined is such doesn't exist.
    * */
    calcLastReview() {
        const { reviews, isDoubleBlindFormat } = this.props;
        if (reviews && reviews.size) {
            if (isDoubleBlindFormat) {
                return reviews.last().get('id');
            }
            return reviews.reverse().find((review) => !review.get('is_seller')).get('id');
        }
    }

    render() {

        const {
            reviews,
            starSummary,
            showLoadMore,
            totalCount,
            type,
            fetchReviews,
            gigId,
            pathFinderConfig,
            isDoubleBlindFormat
        } = this.props;

        const lastReview = this.calcLastReview();

        const headerProps = {
            totalCount,
            ratingFive: this.calcRatingBaseFive(),
            toggleCollapsed: this.toggleCollapsed,
            fetchReviews,
            type,
            lastReview,
            pathFinderConfig
        };

        const showReviewsList = reviews && reviews.size > 0;
        const showNoReviews = !showReviewsList;

        return (

            <div className={this.mainClassName()}>

                <Header {...headerProps}/>

                <div className="reviews-wrap">
                    { starSummary && <RankingUser starSummary={starSummary} isDoubleBlindFormat={isDoubleBlindFormat}/> }
                    {showReviewsList && <ReviewsList reviews={reviews}
                        type={type}
                        fetchReviews={fetchReviews}
                        lastReview={lastReview}
                        showLoadMore={showLoadMore}
                        gigId={gigId}
                        pathFinderConfig={pathFinderConfig}
                        isDoubleBlindFormat={isDoubleBlindFormat}
                        noRanking={!starSummary}/>}
                </div>
                {showNoReviews && <NoReviews reviews={reviews}
                    type={type}/>}

            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    reviews: state.get('stars') || state.get('reviews'),
    averageValuation: state.get('average_valuation') || state.get('user_rating'),
    starSummary: state.get('star_summary'),
    totalCount: state.get('total_count'),
    showLoadMore: state.get('has_more_pages'),
    type: state.get('type'),
    gigId: state.get('gig_id') || state.get('gigId'),
    pathFinderConfig: state.get('pathFinderConfig'),
    isDoubleBlindFormat: state.get('is_double_blind_format')
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

Index.defaultProps = {
    totalCount: 0
};

Index.propTypes = {
    reviews: PropTypes.object,
    averageValuation: PropTypes.number,
    starSummary: PropTypes.object,
    totalCount: PropTypes.number,
    showLoadMore: PropTypes.bool,
    type: PropTypes.string,
    gigId: PropTypes.number,
    isDoubleBlindFormat: PropTypes.bool,
    pathFinderConfig: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/reviews/Reviews.js